module.exports = __webpack_public_path__ + "img/NocodingQuestion.40fa725b.svg";